import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { handleImage } from "../../../apis/color-region/index";
import { Toast } from '../../../components/alert'
import {
    Box,
    Button,
    CircularProgress,
    Typography,
    TextField,
    IconButton,
} from '@mui/material';

import { ArrowBack as ArrowBackIcon, Close as CloseIcon, Add as AddIcon } from '@mui/icons-material';

const ImagePage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [imagePreview, setImagePreview] = useState(null);
    const [imageBinary, setImageBinary] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isNew, setIsNew] = useState(true);
    const [error, setError] = useState('');





    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
            if (img.width === 400 && img.height === 600) {
                setImagePreview(URL.createObjectURL(file));
                const reader = new FileReader();
                reader.onload = () => setImageBinary(file);
                reader.readAsArrayBuffer(file);
                setError('');
            } else {
                setError('Image must be exactly 400x600 pixels.');
            }
        };
    };

    const handleRemoveImage = () => {
        setImagePreview(null);
        setImageBinary(null);
        setError('');
    };

    const handleSubmit = async () => {
        if (!imageBinary) {
            setError(prev => ('Please upload an image before submitting.'));
            return;
        }
        setLoading(true);
        try {

            const payload = { image: imageBinary };
            await handleImage('/api/color-pictures', payload, 'POST')
            navigate('/color-Region');
            Toast('success', 'Image uploaded successfully');
        } catch (error) {
            console.error('Error saving image:', error);
            setError('Failed to save the image. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div>
                <ArrowBackIcon
                    sx={{
                        cursor: 'pointer'
                    }}
                    onClick={() => {
                        navigate(
                            '/color-region'
                        )
                    }}
                />
            </div>
            <Box
                sx={{
                    padding: '20px',
                    maxWidth: '700px',
                    margin: '0 auto',
                    animation: 'fadeIn 0.8s ease-in-out',
                    '@keyframes fadeIn': {
                        from: { opacity: 0 },
                        to: { opacity: 1 },
                    },
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    position: 'relative',
                }}
            >
                {/* Back Button */}
                <IconButton
                    onClick={() => navigate(-1)}
                    sx={{
                        position: 'fixed',
                        top: '20px',
                        left: '20px',
                        backgroundColor: '#f5f5f5',
                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                        zIndex: 1000,
                        '&:hover': {
                            backgroundColor: '#e0e0e0',
                        },
                    }}
                >

                </IconButton>

                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: '#333',
                        marginBottom: '30px',
                    }}
                >
                    {isNew ? 'Upload New Image' : 'Update Image'}
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '20px',
                    }}
                >

                    {imagePreview ? (
                        <Box
                            sx={{
                                position: 'relative',
                                width: '400px',
                                height: '600px',
                                border: '2px solid #ddd',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 6px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease',
                                '&:hover': {
                                    transform: 'scale(1.03)',
                                },
                            }}
                        >
                            <img
                                src={imagePreview}
                                alt="Preview"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)', // No hover effect
                                    },
                                }}
                                onClick={handleRemoveImage}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    ) : (
                        <Button
                            variant="outlined"
                            component="label"
                            startIcon={<AddIcon />}
                            sx={{
                                width: '400px',
                                height: '600px',
                                border: '2px dashed #bbb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#555',
                                backgroundColor: '#fff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                },
                            }}
                        >
                            Click to Upload
                            <input
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={handleImageUpload}
                            />
                        </Button>
                    )}
                    {error && (
                        <Typography
                            variant="body2"
                            color="error"
                            sx={{
                                marginTop: '10px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                            }}
                        >
                            {error}
                        </Typography>
                    )}


                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={loading}
                        sx={{
                            backgroundColor: '#C84B96',
                            color: '#fff',
                            borderRadius: 2,
                            textTransform: 'capitalize',
                            '&:hover': {
                                backgroundColor: '#9B3A73',
                            },
                        }}
                    >
                        {!loading ? 'Create' : <CircularProgress />}
                    </Button>
                </Box>
            </Box>
        </div>
    );
};

export default ImagePage;